var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MglMap',{staticClass:"MapBox",attrs:{"accessToken":_vm.accessToken,"mapStyle":_vm.mapStyle},on:{"update:mapStyle":function($event){_vm.mapStyle=$event},"load":_vm.onMapLoaded}})}
var staticRenderFns = []

export { render, staticRenderFns }